module.exports = __webpack_public_path__ + "static/mobile-50098a56d53f604a001c73775517b354.mp4";